import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  icon,
  rightIcon,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full flex flex-col gap-1.5" data-id="element-115">
        {label && <label className="text-sm font-medium text-gray-700" data-id="element-116">{label}</label>}
        <div className="relative flex items-center" data-id="element-117">
          {icon && <div className="absolute left-3 text-gray-400" data-id="element-118">{icon}</div>}
          <input ref={ref} className={`
              w-full rounded-xl border bg-white px-4 py-3 text-sm text-gray-900 
              transition-colors focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary
              ${error ? 'border-error' : 'border-gray-200'}
              ${icon ? 'pl-10' : ''}
              ${rightIcon ? 'pr-10' : ''}
              ${className}
            `} {...props} data-id="element-119" />
          {rightIcon && <div className="absolute right-3 text-gray-400" data-id="element-120">{rightIcon}</div>}
        </div>
        {error && <span className="text-xs text-error" data-id="element-121">{error}</span>}
      </div>;
});
Input.displayName = 'Input';